<template>
  <div id="messageList">
    <section>
      <div class="messageList" v-if="selectedEvent.messages && selectedEvent.messages.length > 0">
        <div v-if="selectedEvent.messages && selectedEvent.messages.length > 0">
          <div v-for="(message, i) in selectedEvent.messages" v-bind:key="i" class="message">
            <div class="messageHeading">{{ message.sender.givenName }} {{ message.sender.familyName }}, {{ formattedDateTimeString(message.dateTime.toDate(), selectedEvent.location, appUser.timeZoneIdentifier) }}</div>
            <div :class="appUser && (appUser.uid == message.sender.userId) ? 'messageBody_sender' : 'messageBody_notSender'">{{ message.body }}</div>
          </div>
        </div>
        <div v-else>
          <p class="emptyList">No messages</p>
        </div>
      </div>

      <div class="bottomBar">
        <!-- <input type="text" placeholder="Text" ref="inputField" /> -->
        <div class="grow-wrap">
          <textarea name="text" id="text" ref="inputField" onInput="this.parentNode.dataset.replicatedValue = this.value"></textarea>
        </div>
        <button @click="sendMessage(selectedEvent, appUser)">Send</button>
      </div>      
    </section>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  import moment from "moment"
  const fb = require("../firebaseConfig.js")
  import firebase from 'firebase/app';

  export default {
    data() {
      return {
      };
    },
    computed: {
      ...mapState([ "authUser", "appUser", "selectedEvent" ])
    },
    methods: {
      mostRecentMessage(messages) {
        const sortedEventMessages = messages.sort((a,b) => a.dateTime < b.dateTime);
        return sortedEventMessages[sortedEventMessages.length - 1]; // we already know there's at least 1
      },
      sendMessage(event, appUser) {
        let messageBody = this.$refs.inputField.value;
        let eventReference = fb.eventsCollection.doc(event.id)

        let transaction = fb.db.runTransaction(t => {
          return t.get(eventReference).then(eventDocument => {
            const freshEvent = eventDocument.data()

            // Look up the sender invitation so we can reuse their invitee object as the message sender object
            var senderInvitationIndex = freshEvent.invitations.findIndex(invitation => invitation.invitee.phoneNumber === appUser.phoneNumber)
            if (senderInvitationIndex != -1) {
              let senderInvitation = freshEvent.invitations[senderInvitationIndex];
              let message = {
                body: messageBody,
                dateTime: firebase.firestore.Timestamp.fromDate(new Date()),
                isPinned: false,
                sender: senderInvitation.invitee
              };
              if (!freshEvent.messages) {
                freshEvent.messages = [];
              }
              freshEvent.messages.push(message);

              // Set the change statuses of all OTHER invitations to .eventMessagesAdded
              freshEvent.invitations.forEach(invitation => {
                if (invitation.invitee.phoneNumber != appUser.phoneNumber) {
                  this.setChangeStatusForUserInvitation(invitation, this.$InvitationChangeStatus.eventMessagesAdded)
                }
              })

              this.selectedEvent.messages = freshEvent.messages;

              t.update(eventReference, { messages: freshEvent.messages, invitations: freshEvent.invitations });
            }
          });
        }).then(result => {
          console.log("sendMessage success!")

          this.$refs.inputField.value = "";
          this.$store.commit('setSelectedEvent', this.selectedEvent);
        }).catch(error => {
          console.log(`sendMessage error: ${error}`)
          this.selectedEvent.messages.pop();
        });
      },
      setChangeStatusForUserInvitation(invitation, changeStatus) {
        if (!invitation.changes) {
          invitation.changes = []
        }
        let change = { createdDateTime: Date(), changeStatus: changeStatus };
        invitation.changes.push(change)
      },
    },
    filters: {
      formatDate(val) {
        if (!val) {
          return "-"
        }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          return val
        }
        return `${val.substring(0, 200)}...`
      }
    }
  }
</script>

<style scoped>
.grow-wrap {
  /* easy way to plop the elements on top of each other and have them both sized based on the tallest one's height */
  display: grid;
}
.grow-wrap::after {
  /* Note the weird space! Needed to preventy jumpy behavior */
  content: attr(data-replicated-value) " ";

  /* This is how textarea text behaves */
  white-space: pre-wrap;

  /* Hidden from view, clicks, and screen readers */
  visibility: hidden;
}
.grow-wrap > textarea {
  /* You could leave this, but after a user resizes, then it ruins the auto sizing */
  resize: none;

  /* Firefox shows scrollbar on growth, you can hide like this. */
  overflow: hidden;
}
.grow-wrap > textarea,
.grow-wrap::after {
  /* Identical styling required!! */
  border: 1px solid black;
  padding: 0.5rem;
  font: inherit;

  /* Place on top of each other */
  grid-area: 1 / 1 / 2 / 2;
}

body {
  margin: 2rem;
  font: 1rem/1.4 system-ui, sans-serif;
}

label {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageList.vue